import { useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';

import type { useTheme } from './theme';

// Advance-highlight flash of the FocusPanel card (point B): a one-shot pulse
// of border + background when the focus auto-advances to the next set /
// exercise, so the change is noticeable (the card used to jump silently —
// Antenore + Leonardo 2026-06-08). Driven off cueKey, not cueText, so a
// repeated label still re-fires. useNativeDriver:false — we animate colours,
// not transforms. Extracted from FocusPanel (AP-0b) to keep it under the
// 500-line budget; behaviour unchanged.
export function useAdvanceFlash(
  cueKey: number,
  palette: ReturnType<typeof useTheme>['palette'],
) {
  const flash = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    if (cueKey === 0) return; // skip the initial mount
    flash.setValue(1);
    Animated.timing(flash, {
      toValue: 0,
      duration: 650,
      easing: Easing.out(Easing.quad),
      useNativeDriver: false,
    }).start();
  }, [cueKey, flash]);
  return {
    flashBg: flash.interpolate({
      inputRange: [0, 1],
      outputRange: [palette.surface, palette.brand100],
    }),
    flashBorder: flash.interpolate({
      inputRange: [0, 1],
      outputRange: [palette.border, palette.brand500],
    }),
  };
}
